var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurityEnt(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.06,
    height: 18.659,
    viewBox: "0 0 17.06 18.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_488401",
    "data-name": "Group 488401",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180815",
    "data-name": "Path 180815",
    d: "M185.423,166.883a4.77,4.77,0,0,1,.58.048,1.714,1.714,0,0,1-.349,3.4c-.777.018-1.555-.01-2.332.016a.752.752,0,0,0-.5.242c-.7.859-1.377,1.736-2.057,2.611a2.261,2.261,0,0,1-3.808.008c-1-1.275-1.988-2.552-2.995-3.818a19.153,19.153,0,0,1-2.676-4.777c-.225-.553-.466-1.1-.71-1.645a2.24,2.24,0,0,1,1.2-3.131,19,19,0,0,0,3.9-2.229c.556-.425,1.08-.891,1.6-1.356a2.2,2.2,0,0,1,3.158.008,18.881,18.881,0,0,0,5.477,3.561,2.239,2.239,0,0,1,1.229,3.149c-.552,1.256-1.119,2.506-1.677,3.76A1.119,1.119,0,0,0,185.423,166.883Zm-12.262-4.794c1,3.66,3.395,6.418,5.714,9.266l.856-1.1c-.1-.057-.163-.1-.228-.131a1.69,1.69,0,0,1-.871-1.964,1.709,1.709,0,0,1,1.707-1.261c.535,0,1.071-.016,1.606.005a.528.528,0,0,0,.579-.314c.689-1.457,1.385-2.912,2.076-4.368.014-.029,0-.072-.007-.128a21,21,0,0,1-5.737-3.733A20.923,20.923,0,0,1,173.161,162.09Zm9.111,8.242c-.586,0-1.071-.022-1.552.012a.8.8,0,0,0-.494.253c-.376.432-.717.894-1.071,1.345q-.3.377-.591,0c-1.239-1.6-2.515-3.177-3.706-4.813a27.529,27.529,0,0,1-2.423-5c-.123-.271.06-.39.277-.485a19.733,19.733,0,0,0,5.855-3.815.367.367,0,0,1,.59.007,19.643,19.643,0,0,0,5.858,3.809.382.382,0,0,1,.225.6c-.189.4-.349.818-.534,1.223-.522,1.139-1.05,2.275-1.587,3.436.4,0,.829-.017,1.256.006a.444.444,0,0,0,.5-.3c.606-1.372,1.241-2.731,1.826-4.112a1.485,1.485,0,0,0-.434-1.77,3.1,3.1,0,0,0-.816-.478,18.66,18.66,0,0,1-5.333-3.51,1.691,1.691,0,0,0-2.517-.01,16.014,16.014,0,0,1-2.045,1.656c-1.161.727-2.381,1.361-3.6,1.991a1.7,1.7,0,0,0-.874,2.294c.2.466.412.93.609,1.4a19.138,19.138,0,0,0,2.285,4.345q1.786,2.338,3.62,4.639a1.609,1.609,0,0,0,2.432.094C180.794,172.27,181.487,171.325,182.272,170.332Zm.7-.6c.892,0,1.784,0,2.675,0a1.119,1.119,0,1,0,.017-2.236q-2.675-.015-5.35,0a1.1,1.1,0,0,0-1.154,1.146,1.111,1.111,0,0,0,1.175,1.092C181.216,169.738,182.1,169.735,182.975,169.735Z",
    transform: "translate(-170.334 -155.582)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180816",
    "data-name": "Path 180816",
    d: "M265.526,248.287a6.982,6.982,0,0,1-.013.935c-.019.14-.157.35-.271.373-.234.046-.313-.158-.315-.372,0-.3,0-.61,0-.9-.9-.479-1.217-1.024-1.016-1.736a1.357,1.357,0,0,1,1.392-1.015,1.385,1.385,0,0,1,1.281,1.162A1.436,1.436,0,0,1,265.526,248.287Zm.472-1.349a.773.773,0,0,0-1.546-.025.773.773,0,1,0,1.546.025Z",
    transform: "translate(-256.7 -238.682)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180817",
    "data-name": "Path 180817",
    d: "M318.433,323.128l-.346-.413c.124-.1.244-.258.375-.269.1-.008.222.17.334.265Z",
    transform: "translate(-306.785 -309.682)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180818",
    "data-name": "Path 180818",
    d: "M300.526,323.13l-.353-.45c.118-.09.236-.249.353-.249s.235.16.352.25Z",
    transform: "translate(-290.241 -309.668)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180819",
    "data-name": "Path 180819",
    d: "M336.417,323.127l-.354-.425c.116-.092.24-.263.347-.254.127.011.239.179.358.279Z",
    transform: "translate(-323.386 -309.682)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180820",
    "data-name": "Path 180820",
    d: "M354.356,323.13l-.355-.413c.124-.1.241-.259.373-.272.1-.01.309.168.309.262C354.682,322.823,354.515,322.938,354.356,323.13Z",
    transform: "translate(-339.952 -309.68)",
    fill: "#8e92a4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityEnt);
export default __webpack_public_path__ + "static/media/security_ent.8b4e7303f13c686897d0f67043127231.svg";
export { ForwardRef as ReactComponent };